// extracted by css-extract-rspack-plugin
export default {"container":"u5rmue2_bvgId5cG","userProfile":"iiJIYRmPSngM2hyP"};